
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import InvoiceHeader from '@/components/invoice/InvoiceHeader.vue';
import InvoiceSummaryCard from '@/components/invoice/InvoiceSummaryCard.vue';
import TabsUnderline from '@/components/tabs/TabsUnderlineNew.vue';
import InvoiceTable from '@/components/invoice/InvoiceTable.vue';
import TableView from '@/components/invoice/admin/TableView.vue';
import Tooltip from '@/components/common/Tooltip.vue';
import BadgeInfoIcon from '@/components/icons/BadgeInfoIcon.vue';

import InvoiceTabs from '@/components/invoice/InvoiceTabs.vue';

import Alarm from '@/components/icons/invoice/Alarm.vue';
import NavGrayArrow from '@/components/icons//NavGrayArrow.vue';

import AdminPaymentIcon from '@/components/icons/invoice/AdminPaymentIcon.vue';

import ActionIcon from '@/components/icons/ActionIcon.vue';

import CopyLink from '@/components/icons/CopyLink.vue';
import TableViewIcon from '@/components/icons/TableViewIcon.vue';
import PaymentPendingLogo from '@/components/icons/invoice/PaymentPendingLogo.vue';
import PaymentReceivedLogo from '@/components/icons/invoice/PaymentReceivedLogo.vue';
import RouteNames from '@/entities/RouteNames';

import LIST_INVOICE from '@/apollo/invoice/ListInvoice.gql';
import UPDATE_INVOICE from '@/apollo/invoice/UpdateInvoice.gql';
import S3Image from '@/components/common/s3-image.vue';
import ChevronIcon from '@/components/icons/ChevronIcon.vue';

import GET_AMOUNT from '@/apollo/invoice/GetAmount.gql';
import GET_WORKED_HOUR from '@/apollo/invoice/GetWorkedHours.gql';
import GET_INVOICE_COUNT from '@/apollo/invoice/GetInvoiceCount.gql';
import CREATE_NOTIFICATION from '@/apollo/notifications/CreateNotifications.gql';
import { NOTIFICATION } from '@/entities/Events';
import Message from '@/data/notificationsMessages';
import storage from '@/services/storage';

import UiButton from '@/components/button/ui-button.vue';
import TooltipVariants from '@/entities/TooltipVariants';
import Pagination from "@/components/v2/Pagination.vue";
import { Invoice_Bool_Exp, Invoice_Order_By, Timesheet_Order_By, User } from '@/generated/graphql';
import CancelInvoiceModal from '@/components/invoice/modal/CancelInvoiceDialog.vue';
import { INVOICE_VALUE_TO_STATUS } from '@/entities/InvoicesStatus';
import Table_status_icon from '@/components/icons/Table_status_icon.vue';

@Component({
	components: {
		Table_status_icon,
		InvoiceHeader,
		Pagination,
		InvoiceSummaryCard,
		CancelInvoiceModal,
		TabsUnderline,
		InvoiceTable,
		InvoiceTabs,
		TableView,
		TableViewIcon,
		CopyLink,
		ChevronIcon,
		S3Image,
		UiButton,
		AdminPaymentIcon,
		NavGrayArrow,
    Tooltip,
    BadgeInfoIcon,
	},
})

export default class InvoiceDashboard extends Vue {
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
  TooltipVariants = TooltipVariants;
  cards: any = [
	  {
			id: 1,
			icon: this.currentUser.role === 'ADMIN' ? AdminPaymentIcon : Alarm,
			color: 'invoice-color-green',
			description: this.currentUser.role === 'ADMIN' ? 'Payments Sent To Date' : 'Payments Received To Date',
			amount: 'CAD $0',
		},
		{
			id: 2,
			icon: PaymentPendingLogo,
			color: 'invoice-color-yellow',
			description: 'Pending Approval',
			amount: 'CAD $0',
		},
	];
	openDropdown = null;
	isOpen = false;
	invoiceHours = 0;
	count: number = 0;
	seletedInvoiceForDelete = null;
	toggleDropdown(itemId) {
		this.openDropdown = this.openDropdown === itemId ? null : itemId;
	}
	closeDropdown() {
		this.openDropdown = null;
	}
	tableActions = [
		{ name: 'view', icon: TableViewIcon },
		{ name: 'copy', icon: CopyLink },
		{ name: 'action', icon: ActionIcon },
	];
	columns = [
		{ label: 'Reference Number', field: 'referenceNumber' },
		{ label: 'Resource Name', field: 'submittedBy' },
		{ label: 'Total Hours', field: 'totalHours' },
		{ label: 'Total Amount', field: 'totalAmount' },
		{ label: 'Submission Date', field: 'submissionDate', sort: true},
		{ label: 'Status', field: 'status', sort: true, icon: Table_status_icon },
	];

	activeTabIndex: number = Number(this.$route.query.tab || 0);
	tabs = [
		{ name: 'All', badge: 0 },
		{ name: 'Pending Approval', badge: 0 },
		{ name: 'Approved', badge: 0 },
	];

	headers = [
		{ text: 'Reference number', value: 'reference_number' },
		{
			text: 'Link to external invoice',
			value: 'Invoice_link',
			isLink: true,
		},
		{ text: 'Total hours', value: 'total_hours' },
		{ text: 'Total amount', value: 'total_amount' },
		{ text: 'Submission Date', value: 'created_at',  sort: true  },
		{ text: 'Status', value: 'status', badge: true,  sort: true, icon: Table_status_icon  },
		{ text: '', value: '', action: true },
	];
	selectedItems = [];
	selectedRows = [];
	invoiceData = [];
  limit: number = Number(this.$route.query.limit || 10);
  currentPage: number = Number(this.$route.query.page || 1);
  offset: number = this.currentPage >= 1 ? (this.currentPage  - 1) * this.limit: 0;
	totalRecords = 0;
	where: Invoice_Bool_Exp = {};
	sortBy = this.$route.query.sort_by || 'created_at';
	orderBy: Invoice_Order_By[] = [];
  sortDirection = this.$route.query.sort_direction || null;

  get contructOrderBy() {
    const orderBy = { created_at: 'desc' }
    let orderby = [];
	if (this.sortBy === "status") {
      orderby = [
        {...orderBy,
          status: this.sortDirection,
        },
      ];
    }else if(this.sortBy === 'created_at' || this.sortBy === 'submissionDate'){
      orderby = [
        {...orderBy,
          created_at: this.sortDirection || 'desc'
        },
      ];
    }else {
      orderby = [orderBy];

    }
    return orderby;
  }
  handleSort({ sortBy, sortDirection }) {
    //order by
    this.sortBy = sortBy;
    this.sortDirection = sortDirection;
    const {scroll, ...rest} = this.$route.query
    this.$router.push({
      name: this.$route.name, // Keep the current route name
      query: {
        ...rest, // Spread the existing query parameters
        sort_by: sortBy, // Update the 'page' parameter
        sort_direction: sortDirection,
      },
    });
    this.orderBy = this.contructOrderBy;
  }
  @Watch("currentPage")
  @Watch("activeTabIndex")
  @Watch("limit")
 changeRouteQuery() {
    const offset = (this.currentPage - 1) * this.limit;
    this.offset = offset > 0 ? offset : 0;
    const { scroll, ...rest } = this.$route.query;
    this.$router.push({
      name: this.$route.name, // Keep the current route name
      query: {
        ...rest, // Spread the existing query parameters
        tab: this.activeTabIndex?.toString(), // Update the 'page' parameter
        limit: this.limit?.toString(), // Update the 'limit' parameter
        page: this.currentPage?.toString(), // Update the 'page' parameter
        offset: this.offset?.toString(), // Update the 'page' parameter
      },
    });
  }
  get getUerRole () {
	return this.currentUser.role === 'ADMIN'
  }
  get getStatus(){
			let status = null;
			const tab = Number(this.activeTabIndex || 0)
		const isAdmin = this.getUerRole
		if(tab === 1) status = INVOICE_VALUE_TO_STATUS.PENDING
		if(tab === 2) status = INVOICE_VALUE_TO_STATUS.APPROVED
		if(tab === 3) status = isAdmin ?  INVOICE_VALUE_TO_STATUS['PAYMENT SEND'] : INVOICE_VALUE_TO_STATUS.REJECTED
		if(tab === 4) status =INVOICE_VALUE_TO_STATUS.CANCEL
		return status;
  }
	@Watch('$route.query')
	queryWatch() {
		this.orderBy = this.contructOrderBy;
		this.fetchInvoices(this.getStatus);
	}

	@Watch("activeTabIndex")
	handleTabChange(index) {
		this.invoiceData = [];
		this.offset = 0; 
		this.activeTabIndex = index;
	}

	async fetchInvoices(status?: string) {
		try {
			const variables: any = {
				limit: this.limit,
				offset: this.offset,
          		order_by: this.orderBy,
			};

			if (status) {
				variables.where = {
					status: {
						_eq: status,
					},
					...(this.currentUser.role === 'ADMIN' && {
						company_id: { _eq: this.currentUser.admin.company.id },
					}),
					...this.where
				};
			} else if (this.currentUser.role === 'ADMIN') {
				variables.where = {
					status: {
						_neq: 'CANCEL',
					},
					company_id: { _eq: this.currentUser.admin.company.id },
					...this.where
				};
			}
			if (this.currentUser.role !== 'ADMIN') {
				variables.where = {
					...(variables.where && variables.where),
					submit_by: { _eq: this.currentUser.id },
					...this.where
				};
			}
			const response = await this.$apollo.query({
				query: LIST_INVOICE,
				variables: variables,
				fetchPolicy: 'network-only',
			});
			 this.count = response.data.invoice_aggregate.aggregate.count;
			this.invoiceData = this.mapInvoiceData(response.data.invoice);
			this.totalRecords = response.data.invoice_aggregate.aggregate.count;
			this.invoiceHours =  response.data.invoice.reduce((sum, invoice) => {
      		return sum + invoice.total_hours;
   				 }, 0);
		} catch (error) {}
	}


	async getDashboardVal() {
		this.cards = [
			{
				id: 1,
				icon:
					this.currentUser.role === 'ADMIN'
						? AdminPaymentIcon
						: Alarm,
				color: 'invoice-color-green',
				description: this.currentUser.role === 'ADMIN' ? 'Payments Sent To Date' : 'Payments Received To Date',
				amount: 'CAD $0',
			},
			{
				id: 2,
				icon: PaymentPendingLogo,
				color: 'invoice-color-yellow',
				description: 'Pending Approval',
				amount: 'CAD $0',
			},
		];
		try {
			const res = await Promise.all([
				this.$apollo.query({
					query: GET_AMOUNT,
					variables: {
						where: {
							status: { _eq: 'PAID' },
							...(this.currentUser.role !== 'ADMIN' && {
								submit_by: { _eq: this.currentUser.id },
							}),
							...(this.currentUser.role === 'ADMIN' && {
								company_id: {
									_eq: this.currentUser.admin.company.id,
								},
							}),
						},
					},
					fetchPolicy: 'network-only',
				}),
				this.$apollo.query({
					query: GET_AMOUNT,
					variables: {
						where: {
							status: { _eq: 'PENDING' },
							...(this.currentUser.role !== 'ADMIN' && {
								submit_by: { _eq: this.currentUser.id },
							}),
							...(this.currentUser.role === 'ADMIN' && {
								company_id: {
									_eq: this.currentUser.admin.company.id,
								},
							}),
						},
					},
					fetchPolicy: 'network-only',
				}),
			]);
			res.forEach((item, idx) => {
				if (item.data.invoice_aggregate.aggregate.sum.total_amount) {
					this.cards[idx].amount = `CAD $${this.formatNumber(
						item.data.invoice_aggregate.aggregate.sum.total_amount
					)}`;
				}
			});
			if (this.currentUser.role !== 'ADMIN') {
				this.cards.push({
					id: 3,
					icon: PaymentReceivedLogo,
					color: 'invoice-color-blue',
					description: 'Total Hours Worked',
					amount: `${this.invoiceHours} hr${this.invoiceHours > 0 ? `s` : ''}`,
				});
				}
				else {
				this.cards.pop();
				const res = await this.$apollo.query({
					query: GET_INVOICE_COUNT,
					variables: {
						where: { status: { _eq: 'PENDING' }, 
						...(this.currentUser.role !== 'ADMIN' && {
								submit_by: { _eq: this.currentUser.id },
							}),
							...(this.currentUser.role === 'ADMIN' && {
								company_id: {
									_eq: this.currentUser.admin.company.id,
								},
							}), },
					},
					fetchPolicy: 'network-only',
				});
				this.cards.unshift({
					id: 2,
					icon: PaymentPendingLogo,
					color: 'invoice-color-yellow',
					description: 'Pending Approval',
					amount: `${res.data.invoice_aggregate.aggregate.count} invoices`,
				});
			}
		} catch (error) {}
	}

	async getInvoiceCount() {
		try {
			let variable = null;
			let adminQuery = null;
			if (this.currentUser.role !== 'ADMIN') {
				variable = { submit_by: { _eq: this.currentUser.id } };
			} else {
				adminQuery = {
					status: { _neq: 'CANCEL' },
					company_id: { _eq: this.currentUser.admin.company.id },
				};
			}
			const res = await Promise.all([
				this.$apollo.query({
					query: GET_INVOICE_COUNT,
					variables: {
						where: {
							...(variable && variable),
							...(adminQuery && adminQuery),
						},
					},
					fetchPolicy: 'network-only',
				}),
				this.$apollo.query({
					query: GET_INVOICE_COUNT,
					variables: {
						where: {
							status: { _eq: 'PENDING' },
							...(variable && variable),
							...(this.currentUser.role === 'ADMIN' && {
								company_id: {
									_eq: this.currentUser.admin.company.id,
								},
							}),
						},
					},
					fetchPolicy: 'network-only',
				}),
				this.$apollo.query({
					query: GET_INVOICE_COUNT,
					variables: {
						where: {
							status: { _eq: 'APPROVED' },
							...(variable && variable),
							...(this.currentUser.role === 'ADMIN' && {
								company_id: {
									_eq: this.currentUser.admin.company.id,
								},
							}),
						},
					},
					fetchPolicy: 'network-only',
				}),
				this.$apollo.query({
					query: GET_INVOICE_COUNT,
					variables: {
						where: {
							status: { _eq: 'REJECTED' },
							...(variable && variable),
							...(this.currentUser.role === 'ADMIN' && {
								company_id: {
									_eq: this.currentUser.admin.company.id,
								},
							}),
						},
					},
					fetchPolicy: 'network-only',
				}),
				this.$apollo.query({
					query: GET_INVOICE_COUNT,
					variables: {
						where: {
							status: { _eq: 'CANCEL' },
							...(variable && variable),
							...(this.currentUser.role === 'ADMIN' && {
								company_id: {
									_eq: this.currentUser.admin.company.id,
								},
							}),
						},
					},
					fetchPolicy: 'network-only',
				}),
				this.$apollo.query({
					query: GET_INVOICE_COUNT,
					variables: {
						where: {
							status: { _eq: 'PAYMENT SEND' },
							...(variable && variable),
							...(this.currentUser.role === 'ADMIN' && {
								company_id: {
									_eq: this.currentUser.admin.company.id,
								},
							}),
						},
					},
					fetchPolicy: 'network-only',
				}),
			]);
			res.forEach((item, idx) => {
				if (this.currentUser.role !== 'ADMIN') {
					if (idx === 3) {
						this.tabs.push({
							name: 'Rejected',
							badge:
								item.data.invoice_aggregate.aggregate.count ??
								0,
						});
						return;
					}
					if (idx === 4) {
						this.tabs.push({
							name: 'Cancelled',
							badge:
								item.data.invoice_aggregate.aggregate.count ??
								0,
						});
						return;
					}

					this.tabs[idx].badge =
						item.data.invoice_aggregate.aggregate.count ?? 0;
				} else {
					const notAva = this.tabs.find(
						(item) => item.name === 'Payment Sent'
					);
					if (idx === 5) {
						if (!notAva) {
							this.tabs.push({
								name: 'Payment Sent',
								badge:
									item.data.invoice_aggregate.aggregate
										.count ?? 0,
							});
						} else {
							this.tabs[3].badge =
								item.data.invoice_aggregate.aggregate.count;
						}

						return;
					}
					if (this.tabs[idx]) {
						this.tabs[idx].badge =
							item.data.invoice_aggregate.aggregate.count;
					}
				}
			});
		} catch (error) {}
	}
	formatNumber(value) {
		return new Intl.NumberFormat('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(value);
	}
	mounted() {
		this.fetchInvoices(this.getStatus)
      .then(() => {
        this.getDashboardVal();
        this.getInvoiceCount();
      })
      .catch(error => {
        console.error('Error fetching invoices:', error);
      });
		      const {scroll, ...rest} = this.$route.query
    // this.$router.push({
    //   name: this.$route.name, // Keep the current route name
    //   query: {
    //     ...rest, // Spread the existing query parameters
    //     tab: this.activeTabIndex?.toString(), // Update the 'page' parameter
    //     limit: this.limit?.toString(), // Update the 'limit' parameter
    //     page: this.currentPage?.toString(), // Update the 'page' parameter
    //     offset: this.offset?.toString(), // Update the 'page' parameter
    //   },
    // });

	}

// 	changePage(direction) {
//     const nextPage = this.currentPage + direction;
//     if (nextPage > 0 && nextPage <= this.totalPages) {
//       //set limit in query
//       this.currentPage = nextPage;
// 	  this.offset = (this.currentPage - 1) * this.limit;
//     }
//   }
// 	totalPages() {
// 		return Math.ceil(this.totalRecords / this.limit);
// 	}
	 onLimitChange(limit) {
    const lmit = this.limit;
    this.limit = Number(limit);
    if (lmit < this.limit) {
      const newPages = Math.ceil(this.count / this.limit);
      if (this.currentPage > newPages) {
        this.currentPage = newPages;
      }
    }
  }
    changePage(direction) {
    const nextPage = this.currentPage + direction;
    if (nextPage > 0 && nextPage <= this.totalPages) {
      //set limit in query
      this.currentPage = nextPage;
    }
  }
  get totalPages() {
    return Math.ceil(this.count / this.limit);
  }

decimalToTimeString(decimalValue) {
  const hours = Math.floor(decimalValue);
  const decimalMinutes = (decimalValue - hours) * 60;
  
  const minutes = Math.round(decimalMinutes);
  return `${hours}h ${minutes}m`;
}

	mapInvoiceData(invoices) {
		if (this.currentUser.role === 'ADMIN') {
			return invoices.map((inv) => {
				const finalFromatedHours = this.decimalToTimeString(inv.total_hours);
			return	{
				id: inv.id,
				referenceNumber: inv.invoice_ref,
				submittedBy: {
					name: this.userFullname(inv?.user),
					image: inv?.user?.avatar,
					initials: this.userShortname(inv?.user),
				},
				totalHours: `${finalFromatedHours}`,
				totalAmount: this.formatCurrency(inv.total_amount),
				submissionDate: inv.invoice_submission_date,
				company: inv.company,
				status: inv.status,

				isOpened: inv.is_opened,
			};
		});
		} else {
			return invoices.map((inv) => {
				const finalFromatedHours = this.decimalToTimeString(inv.total_hours);
			return	{
				id: inv.id,
				submittedBy: {
					name: this.userFullname(inv?.user),
					image: inv?.user?.avatar,
					initials: this.userShortname(inv?.user),
				},
				file: inv.file,
				reference_number: inv.invoice_ref,
				Invoice_link: inv.external_link,
				total_hours: `${finalFromatedHours}`,
				total_amount: this.formatCurrency(inv.total_amount),
				created_at: inv.invoice_submission_date,
				company: inv.company,
				status: inv.status,
				isOpened: inv.is_opened,
			};
		});
		}
	}
	formatCurrency(value) {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		}).format(value);
	}
	createNewInvoice() {
		this.$router.push({ name: RouteNames.INVOICE_SUBMIT });
	}
	handleAction(payload) {
		const { actionName, item } = payload;

		if (actionName === 'sendByEmail') {
			this.sendInvoiceByEmail(item);
		} else if (actionName === 'notifyManager') {
			this.notifyManager(item);
		} else if (actionName === 'cancelInvoice') {
			this.cancelInvoice(item);
		} else if (actionName === 'externalLink') {
			this.onClickExternalLink(item);
		}
	}
	handleEdit(item) {
		this.$router.push(`/invoice/${item.id}`);
	}
	async handleCopy(item) {
		try {
			await navigator.clipboard.writeText(
				`${window.location.origin}/invoice/${item.id}`
			);
			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage(`URL copied to clipboard!`)
			);
		} catch (err) {}
	}
	async onClickExternalLink(item) {
		if (item.file) {
			const filename = item.file.key.split('/')[1];
			const file = await this.getFile(filename);
			window.open(file, '_self');
			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage(`${filename} - loading started`)
			);
		}
	}
	async getFile(filename: string) {
		return await storage
			.get(filename)
			.then((result: any) => result)
			.catch((err: any) => {
				throw err;
			});
	}
	sendInvoiceByEmail(item) {
		const subject = encodeURIComponent(
			`Invoice for [${item.reference_number}] - Action Required`
		);
		const body = encodeURIComponent(
			`Please find attached the invoice for your reference regarding subject cited above for your attention:  ${window.location.origin}/invoice/${item.id}`
		);
		const mailto = `mailto:?subject=${subject}&body=${body}`;
		window.open(mailto, '_blank');
		window.location.href = mailto;
	}
	status(value) {
		switch (value) {
			case 'PENDING':
				return 'Pending Approval';
			case 'APPROVED':
				return 'Invoice Approved';
			case 'REJECTED':
				return 'Invoice Rejected';
			case 'PAID':
				return 'Paid';
			case 'PAYMENT SEND':
				return 'Payment Sent';
			case 'CANCEL':
				return 'Cancelled';
			default:
				break;
		}
		return `${value.toLowerCase().replace(/\s+/g, '-')}`;
	}
	async notifyManager(item) {
		await this.$apollo
			.mutate({
				mutation: CREATE_NOTIFICATION,
				variables: {
					objects: [
						{
							user_id: item.company.admins[0].user_id,
							message: `${item.submittedBy.name} has forwarded an invoice to you for your review.`,
							link: `/invoice/${item.id}`,
							created_by: this.currentUser.id,
						},
					],
				},
			})
			.catch(() => {});
		this.$eventBus.emit(
			NOTIFICATION,
			Message.successMessage(
				`Your admin has been notified to review your invoice.`
			)
		);
	}

	cancelInvoice(item) {
		this.isOpen = true;
		this.seletedInvoiceForDelete = item.id;
	}
	async confirmCancelInvoice(status) {
		await this.$apollo.mutate({
			mutation: UPDATE_INVOICE,
			variables: {
				set: { status: status },
				id: this.seletedInvoiceForDelete,
			},
		});
		// const updatePromises = this.invoiceData.find((activityId) =>
		// 	this.$apollo.mutate({
		// 		mutation: UPDATE_PROJECT_ACTIVITY,
		// 		variables: {
		// 			set: { invoice_id: invoiceId },
		// 			id: activityId.id,
		// 		},
		// 	})
		// );
		// await Promise.all(updatePromises);
		const index = this.invoiceData.findIndex(
			(invoice) => invoice.id === this.seletedInvoiceForDelete
		);

		if (index !== -1) {
			this.$set(this.invoiceData, index, {
				...this.invoiceData[index],
				status: status,
			});
			this.seletedInvoiceForDelete = null;
			this.isOpen = false;
			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage(`Invoice Cancelled`)
			);
		}
	}
	editRow(row) {
		this.$router.push(`/invoice/${row.id}`);
	}
	userFullname(user): any {
		const givenName = user?.given_name ?? '';
		const familyName = user?.family_name ?? '';
		return `${givenName} ${familyName}`;
	}
	userShortname(user): any {
		const givenName = user?.given_name ?? '';
		const familyName = user?.family_name ?? '';
		return `${givenName.charAt(0)} ${familyName.charAt(0)}`;
	}
	async changeSignalStatus(status) {
		const res: any = await this.$apollo.mutate({
			mutation: UPDATE_INVOICE,
			variables: {
				set: { status: status },
				id: this.openDropdown,
			},
		});
		this.getDashboardVal();
		this.getInvoiceCount();
		const index = this.invoiceData.findIndex(
			(invoice) => invoice.id === this.openDropdown
		);

		if (index !== -1) {
			this.$set(this.invoiceData, index, {
				...this.invoiceData[index],
				status: status,
			});
			this.openDropdown = null;
			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage(`Status Successfully Updated`)
			);
		}
	}

	async changeStatus(status) {
		const updatePromises = this.selectedRows.map((invoice) =>
			this.$apollo.mutate({
				mutation: UPDATE_INVOICE,
				variables: {
					set: { status: status },
					id: invoice,
				},
			})
		);

		await Promise.all(updatePromises);
		this.getDashboardVal();
		this.getInvoiceCount();
		this.$eventBus.emit(
			NOTIFICATION,
			Message.successMessage(`Status Successfully Updated`)
		);
		this.selectedRows.forEach((invoice) => {
			const index = this.invoiceData.findIndex(
				(item) => item.id === invoice
			);

			if (index !== -1) {
				this.$set(this.invoiceData, index, {
					...this.invoiceData[index],
					status: status,
				});
				this.selectedRows = [];
			}
		});
	}
}
